$ = require 'jquery'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
Auth = require 'app/scripts/db/auth'
template = require 'app/scripts/views/templates/header_enterprise_deprovisioning'
{ track } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
{ Analytics, getScreenFromUrl } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class EnterpriseDeprovisioningBannerView extends WarningBannerView
  className: Util.extendParentClassName('enterprise-deprovisioning-banner')

  events:
    'click .js-dismiss-enterprise-deprovisioning-banner': 'dismiss'

  initialize: ->
    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  render: ->
    data =
      enterpriseName: @model.displayName
      enterpriseStanding: @model.enterpriseStanding
      pendingDeprovision: @model.pendingDeprovision
    @$el.html template(data)

    if @sendGASEvent
      Analytics.sendViewedBannerEvent
        bannerName: 'enterpriseDeprovisioningBanner'
        source: getScreenFromUrl()


    @

  dismiss: (e) ->
    track("Header", "Enterprise Deprovisioning Banner", "Dismiss")
    if @sendGASEvent
      Analytics.sendDismissedComponentEvent
        componentType: 'banner'
        componentName: 'enterpriseDeprovisioningBanner'
        source: getScreenFromUrl()
        containers:
          enterprise:
            id: @model.idEnterprise

    Auth.me().dismissEnterpriseDeprovisioningBannerFor @model.idEnterprise
    $(e.target).closest('.enterprise-deprovisioning-banner').remove()
    e.preventDefault()
